module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"current":"Текущий","upgrade":"Перейти","downgrade":"Перейти","renewCurrentPlan":"Возобновить","next":"Следующий тариф","from":"от","free":"Бесплатно","plan":"Тариф","price":"Стоимость в месяц","try":"Попробовать","ok":"Ок","cancel":"Отмена","dialogAddPaymentMethodTitle":"Необходимо добавить способ оплаты","unlimited":"Неограниченно"}}')
  delete Component.options._Ctor
}
